<template>
    <div id="data-list-list-view" class="data-list-container" v-if="wills">
        <ToPrintTable
            :data="wills"
            :itemsPerPage="itemsPerPage"
            :dataSelected="selected"
            @selected="selected = $event"
            @itemsPerPage="setItemsPerPage"
            @print="printWills"
            @search="search"
            @sort="sort"
        ></ToPrintTable>
        <vs-pagination
            :total="wills.number_of_pages"
            v-model="pageNumber"
        ></vs-pagination>
        <PrintModal
            :show="show.printModal"
            :selected="selected"
            @refresh="getPage"
            @close="closePrintModal"
        ></PrintModal>
    </div>
</template>

<script>
import { tableHelpers } from '@/mixins/tableHelpers'
import { http } from '@/services'

import ToPrintTable from './Table'
import PrintModal from './PrintModal'

export default {
    name: 'WillsToPrint',
    mixins: [tableHelpers],
    components: {
        ToPrintTable,
        PrintModal,
    },
    mounted() {
        this.getPage()
    },
    watch: {
        pageNumber(value) {
            if (value) this.getPage()
        },
    },
    computed: {
        willsData() {
            if (this.wills && this.wills.data) return this.wills.data
            return []
        },
    },
    data() {
        return {
            wills: null,
            pageNumber: 1,
            itemsPerPage: 10,
            selected: [],
            queriedItems: 20,
            selectedPdf: null,
            query: null,
            show: {
                printModal: false,
            },
            sortKey: 'checked_date',
            sortActive: 'asc',
        }
    },
    methods: {
        addNewData() {
            console.log('add new data')
        },
        setItemsPerPage(value) {
            this.itemsPerPage = value
            this.getPage()
        },
        setPageNumber(value) {
            this.pageNumber = value
            this.getPage()
        },
        getPage() {
            http.get('wills_list', {
                params: {
                    limit: 'to_print',
                    items_per_page: this.itemsPerPage,
                    page_number: this.pageNumber,
                    query: this.query,
                    sort: [this.sortKey, this.sortActive],
                },
            })
                .then((response) => {
                    this.wills = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        markAsPrinted() {
            if (this.selected.length) {
                var data = this.selected.map((will) => will.id)

                http.post('wills_print_multiple', data)
                    .then((response) => {
                        this.$vs.notify({
                            text: 'Wills marked as printed',
                            color: 'success',
                        })
                        this.getPage()
                        this.selected = []
                    })
                    .catch((error) => {
                        this.$vs.notify({
                            text: error.response.data,
                            color: 'danger',
                        })
                    })
            }
        },
        search(value) {
            this.query = value
            this.getPage()
        },
        printWills() {
            this.show.printModal = true
        },
        sort(key, active) {
            this.sortKey = key
            this.sortActive = active
          if (key) this.getPage()
        },
        closePrintModal() {
            this.show.printModal = false
            this.selected = []
        },
    },
}
</script>

<style lang="scss">
#data-list-list-view {
    .vs-con-table {
        /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
        @media (max-width: 689px) {
            .vs-table--search {
                margin-left: 0;
                max-width: unset;
                width: 100%;

                .vs-table--search-input {
                    width: 100%;
                }
            }
        }

        @media (max-width: 461px) {
            .items-per-page-handler {
                display: none;
            }
        }

        @media (max-width: 341px) {
            .data-list-btn-container {
                width: 100%;

                .dd-actions,
                .btn-add-new {
                    width: 100%;
                    margin-right: 0 !important;
                }
            }
        }

        .product-name {
            max-width: 23rem;
        }

        .vs-table--header {
            display: flex;
            flex-wrap: wrap;
            margin-left: 1.5rem;
            margin-right: 1.5rem;
            > span {
                display: flex;
                flex-grow: 1;
            }

            .vs-table--search {
                padding-top: 0;

                .vs-table--search-input {
                    padding: 0.9rem 2.5rem;
                    font-size: 1rem;

                    & + i {
                        left: 1rem;
                    }

                    &:focus + i {
                        left: 1rem;
                    }
                }
            }
        }

        .vs-table {
            border-collapse: separate;
            border-spacing: 0 1.3rem;
            padding: 0 1rem;

            tr {
                box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
                td {
                    padding: 20px;
                    &:first-child {
                        border-top-left-radius: 0.5rem;
                        border-bottom-left-radius: 0.5rem;
                    }
                    &:last-child {
                        border-top-right-radius: 0.5rem;
                        border-bottom-right-radius: 0.5rem;
                    }
                }
                td.td-check {
                    padding: 20px !important;
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 0;
                padding-bottom: 0;

                .vs-table-text {
                    text-transform: uppercase;
                    font-weight: 600;
                }
            }
            th.td-check {
                padding: 0 15px !important;
            }
            tr {
                background: none;
                box-shadow: none;
            }
        }

        .vs-table--pagination {
            justify-content: center;
        }
    }
}
</style>
